import { FAQResponseType } from "@/types/post";

import FAQ from "./FAQ";

interface FAQListProps {
  faqs: FAQResponseType[];
}

function FAQList({ faqs }: FAQListProps) {
  if (faqs.length === 0) {
    return <div className="flex flex-col gap-2 px-2 text-center text-20">찾으시는 키워드에 대한 답이 없습니다.</div>;
  }

  return (
    <ul className="flex flex-col gap-2 px-2">
      {faqs.map((faq) => (
        <FAQ key={faq.title} faq={faq} />
      ))}
    </ul>
  );
}

export default FAQList;
